var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15537_68805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77113 93.4199C24.8262 51.2743 55.345 5.45632 101.164 11.8509C154.766 19.3315 201.726 66.4371 199.951 120.52C198.504 164.634 137.592 165.617 95.6655 179.422C71.3305 187.435 44.6735 195.46 26.1585 177.747C3.05361 155.642 -7.39887 122.549 5.77113 93.4199Z",
    fill: "#E7F1F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.5891,
    y: 88.2473,
    width: 100,
    height: 68.75,
    transform: "rotate(-10 48.5891 88.2473)",
    fill: "#669BBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07 70.8825L105.203 45.5414C96.6318 40.3531 85.5437 42.3082 79.2634 50.1153L48.5891 88.2473L147.07 70.8825Z",
    fill: "#4983A5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9224,
    y: 80.5372,
    width: 75,
    height: 66.25,
    transform: "rotate(-10 59.9224 80.5372)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5891 88.2473L152.853 139.673L60.5274 155.953L48.5891 88.2473Z",
    fill: "#4983A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07 70.8825L66.6824 154.868L159.008 138.588L147.07 70.8825Z",
    fill: "#4983A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.008 138.588L117.142 113.247C108.57 108.059 97.4819 110.014 91.2016 117.821L60.5273 155.953L159.008 138.588Z",
    fill: "#669BBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15537_68805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgotPassword.f44ed222092d03a0a18c0a89f8a626ae.svg";
export { ForwardRef as ReactComponent };